import { createSlice } from "@reduxjs/toolkit";

const subMenuClickSlice1 = createSlice({
  name: "subMenuTrakL",
  initialState: false,
  reducers: {
    setSubMenuTrakL: (state, action) => {
      return action.payload;
    },
  },
});

export const { setSubMenuTrakL } = subMenuClickSlice1.actions;
export default subMenuClickSlice1.reducer;
